export const DEFAULT_COURSES = {
  murray: {
    name: "Murray Course",
    subtitle: "Yarrawonga Mulwala Golf Club",
    par: [4, 3, 4, 4, 5, 4, 4, 3, 5, 3, 5, 4, 3, 5, 4, 5, 3, 4],
    si:  [6, 18, 13, 4, 9, 3, 16, 12, 7, 14, 15, 2, 8, 10, 11, 1, 17, 5],
  },
  lakes: {
    name: "Lakes Course",
    subtitle: "Yarrawonga Mulwala Golf Club",
    par: [4, 4, 3, 5, 4, 4, 3, 4, 5, 4, 3, 5, 4, 3, 4, 5, 4, 4],
    si:  [10, 4, 14, 2, 8, 12, 16, 6, 18, 11, 15, 3, 5, 17, 9, 1, 13, 7],
  },
  blackbull: {
    name: "Black Bull",
    subtitle: "Murray Downs",
    par: [4, 5, 3, 4, 4, 5, 3, 4, 4, 4, 3, 5, 4, 3, 4, 5, 4, 4],
    si:  [7, 3, 17, 11, 5, 9, 15, 1, 13, 12, 14, 6, 2, 18, 10, 8, 16, 4],
  },
};

export const TAB_IDS = ["setup", "score", "live", "champ", "bbb"];

export const uid = () => Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4);

// Auto-assign playerIds into groups of preferred size (2-4). Fills evenly.
export function shuffleIds(ids) {
  const a = [...ids];
  for (let i = a.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [a[i], a[j]] = [a[j], a[i]]; }
  return a;
}

export function autoGroups(playerIds, preferredSize = 4) {
  const n = playerIds.length;
  if (n === 0) return [];
  let size = Math.min(4, Math.max(2, preferredSize));
  // Choose group sizes so each group is 2..4
  // Compute number of groups
  let numGroups = Math.ceil(n / size);
  // If remainder gives a group < 2, reduce size
  while (numGroups > 1 && n - (numGroups - 1) * Math.ceil(n / numGroups) < 2) {
    numGroups++;
  }
  const groups = [];
  const base = Math.floor(n / numGroups);
  let remainder = n % numGroups;
  let idx = 0;
  for (let g = 0; g < numGroups; g++) {
    const s = base + (remainder > 0 ? 1 : 0);
    if (remainder > 0) remainder--;
    groups.push({
      playerIds: playerIds.slice(idx, idx + s),
      scores: {},
      bbb: Array.from({ length: 18 }, () => ({ bingo: null, bango: null, bongo: null })),
    });
    idx += s;
  }
  return groups;
}
